import { GameObjects } from "phaser";
import { padNumber, datetimeToUnixTimestamp, formatUnixTimestamp } from "../utils";

export class TimerObject extends GameObjects.Container {
    constructor(scene, x, y) {
        super(scene, x, y);

        // Add this container to the scene
        scene.add.existing(this);

        this.currentDrawInfo = scene.registry.get('currentDraw');

        const draw_date_realTime = datetimeToUnixTimestamp(this.currentDrawInfo?.draw_date)

        var draw_date_unixtime  = draw_date_realTime;
        if(this.currentDrawInfo.status == "closed"){
            const twoMinutesInSeconds = 2 * 60; // 2 minutes in seconds
            draw_date_unixtime += twoMinutesInSeconds
        }

        // Initialize properties
        //this.remainingTime = 1000;
        //this.timerText = scene.add.text(0, 0, '00:00', { fontFamily: 'Oswald', fontSize: 32, color: '#ffffff' }).setOrigin(0.5);


        const boxReletiveSize = 493;
        const boxReletiveSizeD4 = 133;

        const topleftX = 0;
        const topleftY = 0;


        this.remaining_time = draw_date_unixtime

        const remaningTime = this.timeLeft(this.remaining_time)

        this.DaysText = scene.add.bitmapText(topleftX + (1 * boxReletiveSizeD4) - (boxReletiveSizeD4 / 2) - 20, topleftY + 100*2, 'Oswald-Medium', `Days` , 32).setOrigin(0.5,1);
        this.DaysNum = scene.add.bitmapText(topleftX + (1 * boxReletiveSizeD4) - (boxReletiveSizeD4 / 2)- 20, topleftY + 105, 'oswald2', remaningTime.days , 52).setOrigin(0.5);


        this.HoursText = scene.add.bitmapText(topleftX + (2 * boxReletiveSizeD4) - (boxReletiveSizeD4 / 2) - 20, topleftY + 100*2, 'Oswald-Medium', `Hours` , 32).setOrigin(0.5,1);
        this.HoursNum = scene.add.bitmapText(topleftX + (2 * boxReletiveSizeD4) - (boxReletiveSizeD4 / 2) - 20, topleftY + 105, 'oswald2', remaningTime.hours , 52).setOrigin(0.5);

        this.MinutesText = scene.add.bitmapText(topleftX + (3 * boxReletiveSizeD4) - (boxReletiveSizeD4 / 2)-20, topleftY + 100*2, 'Oswald-Medium', `Minutes` , 32).setOrigin(0.5,1);
        this.MinutesNum = scene.add.bitmapText(topleftX + (3 * boxReletiveSizeD4) - (boxReletiveSizeD4 / 2)-20, topleftY+ 105, 'oswald2', remaningTime.minutes , 52).setOrigin(0.5);

        this.SecondsText = scene.add.bitmapText(topleftX + (4 * boxReletiveSizeD4) - (boxReletiveSizeD4 / 2)-20, topleftY + 100*2, 'Oswald-Medium', `Seconds` , 32).setOrigin(0.5,1);
        this.SecondsNum = scene.add.bitmapText(topleftX + (4 * boxReletiveSizeD4) - (boxReletiveSizeD4 / 2) -20, topleftY + 105, 'oswald2', remaningTime.seconds , 52).setOrigin(0.5);

        //this.add(this.timerText);

        this.add(this.DaysText);
        this.add(this.DaysNum);
        this.add(this.HoursText);
        this.add(this.HoursNum);
        this.add(this.MinutesText);
        this.add(this.MinutesNum);
        this.add(this.SecondsText);
        this.add(this.SecondsNum);

        this.NextDraw = scene.add.text(topleftX+boxReletiveSize/2 -30 , topleftY + 48, `Next Draw: ${formatUnixTimestamp(this.remaining_time)}`,  { fontSize: '30px', fontFamily: 'Oswald', color: '#fff', fontWeight:500 }).setOrigin(0.5)
        this.NextDraw.setFontStyle("500")
        //this.NextDraw.preFX.addShadow(0, 0, 0.06, 1, 0x00aaa0, 10, 0.8);

        this.NextDrawGMT = scene.add.text(this.NextDraw.x + this.NextDraw.width/2 +6 , topleftY + 46 + this.NextDraw.height/2, `GMT+8`,  { fontSize: 20, fontFamily: 'Oswald', color: '#fff', fontWeight:500 }).setOrigin(0, 1)
        //this.NextDrawGMT.preFX.addShadow(0, 0, 0.06, 0.75, 0x00aaa0, 4, 0.8);


        this.add(this.NextDraw);
        this.add(this.NextDrawGMT);

        this.colon = []
        for (let index = 1; index < 4; index++) {
          
            this.colon[index] = scene.add.text(topleftX + (index * boxReletiveSizeD4) - (boxReletiveSizeD4/6), topleftY + 150, `:`,   { fontSize: 48, fontFamily: 'Oswald', color: '#fff', fontWeight:500 }).setOrigin(0.5)
            //const element = array[index];
            this.add(this.colon[index]);
        }

        // Also add to the Scene's Update List:
        scene.sys.updateList.add(this);

        


    }

    
    timeLeft(unixTimestamp) {
        // Get the current time and the future time based on the unix timestamp
        const now = new Date().getTime();
        const futureTime = unixTimestamp * 1000; // Convert to milliseconds
    
        // Calculate the time difference
        const timeDiff = futureTime - now;
    
        // Check if the future time is in the past
        if (timeDiff <= 0) {
            return {
                days:  padNumber(0),
                hours: padNumber(0),
                minutes: padNumber(0),
                seconds: padNumber(0)
            };
        }
    
        // Calculate the number of days, hours, minutes, and seconds
        const days = padNumber(Math.floor(timeDiff / (1000 * 60 * 60 * 24)));
        const hours = padNumber(Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
        const minutes = padNumber(Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60)));
        const seconds = padNumber(Math.floor((timeDiff % (1000 * 60)) / 1000));
    
        // Return the results as an object
        return {
            days: days,
            hours: hours,
            minutes: minutes,
            seconds: seconds
        };
    }

    hideNextDraw(){
        this.NextDraw.setVisible(false)
        this.NextDrawGMT.setVisible(false)
    }

    showNextDraw(){
        this.NextDraw.setVisible(true)
        this.NextDrawGMT.setVisible(true)
    }

    preUpdate(time, delta) {
        if(!this.remaining_time){
            return
        }
	
        //this.captureSceneA() 

        const remaningTime = this.timeLeft(this.remaining_time)


        if (+this.DaysNum.text !== +remaningTime.days){
            this.DaysNum.setText(remaningTime.days);
        }
        
        if (+this.HoursNum.text !== +remaningTime.hours){
            this.HoursNum.setText(remaningTime.hours);       
        }

        if (+this.MinutesNum.text !== +remaningTime.minutes){
            this.MinutesNum.setText(remaningTime.minutes);
        }

        if (+this.SecondsNum.text !== +remaningTime.seconds){
            this.SecondsNum.setText(remaningTime.seconds);    
        }
    }
}
